export const priceListOptions = [
  { label: 'Allgemeine Preisliste', value: 0 },
  { label: 'Allgemeine Preisliste für ausgewählte Betriebe', value: 1 },
  { label: 'Individuelle Preisliste', value: 2 },
]
